<template>
  <vs-popup class="agreement-popup" title="필터 교체 동의서" :active.sync="popupActive">
    <div class="text-right no-print">
      <vs-button @click="print">프린트</vs-button>
    </div>
    <div class="agreement-page mt-3">
      <table class="w-full">
        <colgroup>
          <col width="21%" />
          <col width="29%" />
          <col width="19.5%" />
          <col width="30.5%" />
        </colgroup>
        <tbody>
          <tr>
            <td colspan="4" class="text-2xl font-bold">클리닝에 따른 필터 교체 동의서</td>
          </tr>

          <tr>
            <td colspan="4" class="text-left px-3">
              <p class="mt-3 mb-6">
                다음 차량은 장착된 배출가스 저감장치의 성능유지관리를 위한 클리닝의 일환으로 기존 장착 필터를 클리닝(청소)된 필터로 교체하는 것에 동의하였음을 확인합니다.
              </p>
              <span>☐ 장착차량 현황</span>
              <div class="w-full mt-1">
                <table class="w-full" style="table-layout: fixed;">
                  <colgroup>
                    <col width="10%"/>
                    <col width="34%"/>
                    <col width="15%"/>
                    <col width="12%"/>
                    <col width="19%"/>
                    <col width="10%"/>
                  </colgroup>
                  <tr>
                    <td>차량번호</td>
                    <td>{{ audit.vehicleNumber }} / {{ audit.currentVehicleNumber }}</td>
                    <td>차량소유자<br/>(또는 대리인)</td>
                    <td>{{ audit.ownerName }}</td>
                    <td>(대리인일 경우)<br/>소유자와의 관계</td>
                    <td></td>
                  </tr>
                </table>
              </div>
              <p class="mt-12">
                ☐ 장치 현황
              </p>
              <div class="w-full mt-1">
                <table class="w-full" style="table-layout: fixed;">
                  <colgroup>
                    <col width="10%"/>
                    <col width="20%"/>
                    <col width="14%"/>
                    <col width="10%"/>
                    <col width="18%"/>
                    <col width="10%"/>
                    <col width="18%"/>
                  </colgroup>
                  <tr>
                    <td>장치종류</td>
                    <td></td>
                    <td>제품<br/>(일련)번호</td>
                    <td>교체전</td>
                    <td></td>
                    <td>교체후</td>
                    <td></td>
                  </tr>
                </table>
              </div>
              <p class="mt-12">
                ☐ 유의 사항
              </p>
              <p class="mt-3 mb-3" style="line-height: 24px;">
                ◯ 폐차 혹은 수출 등을 위하여 차량등록을 말소하고자 할 경우 보조금 및 장치 반납(금전 반납포함) 의무가 있음<br/>
                &nbsp;&nbsp;&nbsp;- 구조변경검사일~2년(의무사용기간) 이내 : 장치 및 보조금 반납(사용기간별 20~70%)<br/>
                &nbsp;&nbsp;&nbsp;- 2년(의무사용기간) 경과 : 장치만 반납
              </p>
              <p class="mt-3 mb-3" style="line-height: 24px;">
                ◯ 차량소유자는 저감장치 및 그 관련부품을 무단제거 또는 변경할 수 없음<br/>
                &nbsp;&nbsp;&nbsp;- 고의로 탈거한 경우 [자동차 관리법] 제34조에 의거 고발 및 보조금 전액 회수
              </p>
              <p class="mt-3 mb-3" style="line-height: 24px;">
                ◯ 저감장치의 성능이 유지 되도록 차량 및 장치 점검을 수행하여야 함
              </p>
              <p class="mt-6">
                ☐ 작성 참고 사항
              </p>
              <p class="mt-3" style="line-height: 19px;">
                ◯ 장치 종류 기재는 복합중형, 복합대형, 자연중형, 자연대형, 동시저감증 1개를 선택하여 기재
              </p>
              <div>&nbsp;</div>
              <p class="mt-24 mb-12" style="text-align: center;">
                20&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;년&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;월&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;일
              </p>
              <table class="w-full no-border mb-8">
                <colgroup>
                  <col width="40%" />
                  <col width="20%" />
                  <col width="40%" />
                </colgroup>
                <tbody>
                  <tr>
                    <td class="text-left">작성자(차량소유자 또는 차량 운행자) :</td>
                    <td class="text-left">{{ audit.ownerName }}</td>
                    <td class="text-left" style="position: relative;">(인),&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;연락처 (&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ audit.lastPhone }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;)
                    <img :src="audit.signature" style="position: absolute; top: -16px; left: -20px; z-index: 0; width: 64px;">
                  </td>
                  </tr>
                  <tr>
                    <td class="text-left pt-6">확인자(작업자 또는 제작사) 서천 공업사 :</td>
                    <td class="text-left pt-6"></td>
                    <td class="text-left pt-6">(인),&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;연락처 (&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;)</td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </vs-popup>
</template>

<script>
export default {
  data () {
    return {
      popupActive: false,
      audit: {}
    }
  },
  methods: {
    open (audit) {
      this.popupActive = true
      this.audit = audit
    },
    print () {
      const css = '@page { size: portrait; margin: 20px 40px; }'
      const head = document.head || document.getElementsByTagName('head')[0]
      const style = document.createElement('style')

      style.type = 'text/css'
      style.media = 'print'

      if (style.styleSheet) {
        style.styleSheet.cssText = css
      } else {
        style.appendChild(document.createTextNode(css))
      }

      head.appendChild(style)

      window.print()
    }
  }
}
</script>

<style lang="scss">

@media screen {
  .agreement-popup .vs-popup {
    width: 730px !important;
  }
}

@media print {
  #app {
    display: none;
  }
  .no-print {
    display: none;
  }
  .agreement-page {
    display: block !important;
    width: 100%;
    background-color: white;
    position: absolute;
    top: 0;
    left: 0;
    margin: 0;
  }
}

.agreement-popup table {
  // border: 1px solid #c8c8c8;
  border-collapse: collapse;
}

.agreement-popup table td {
  text-align: center;
  padding: 4px 2px;
  border: 1px solid #000;
}

.agreement-popup table th {
  background-color: #efefef;
}

.agreement-popup table th.bg-white {
  border: none;
}

.detail-category-popup .vs-con-input-label {
  width: 100%;
}

.agreement-popup table .no-border td {
  border: none;
}

</style>
